<template>
    <v-dialog width="650" v-model="isOpenViewFactor">
        <v-card>
            <v-card-title primary-title class="d-flex justify-center">
                <div class="d-block">
                    <h2 class="font-weight-light primary--text">
                        {{
                            factorView && factorView.commercial
                                ? factorView.commercial.nombre_completo
                                : selectedComercial
                                ? selectedComercial.nombreCompleto
                                : ''
                        }}
                    </h2>
                    <h4 class="font-weight-light primary--text text-center">
                        {{ currentNameMonthYear }}
                    </h4>
                </div>
            </v-card-title>
            <v-card-text class="pa-1">
                <v-data-table
                    class="py-4"
                    :headers="headers"
                    :items="tableItems"
                    :footer-props="footer_props"
                    disable-pagination
                    hide-default-footer
                    disable-sort
                ></v-data-table>
            </v-card-text>
            <v-card-actions class="d-flex justify-end">
                <v-btn text color="red" @click="isOpenViewFactor = false">
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { dateToISOString } from '@/util/libUtil.js';

export default {
    name: 'correctiveFactorView',
    data: () => ({
        headers: [
            {
                text: 'Porcentaje máximo',
                align: 'center',
                value: 'factor_corrector_name',
                sortable: false,
            },
            {
                text: 'Factor corrector',
                align: 'center',
                value: 'factor_corrector',
                sortable: false,
            },
        ],
        footer_props: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [-1],
        },
    }),
    methods: {
        formatDate(date) {
            return new Date(date).toISOString().substr(0, 7);
        },
    },
    computed: {
        cuenta() {
            return JSON.parse(localStorage.getItem('cuenta'));
        },
        tableItems() {
            if (this.hasManagerPermission && this.factorView) {
                console.log(this.factorView.factor_details);
                let factor_item_sort = [
                    ...Object.values(this.factorView.factor_details),
                ].sort(function (a, b) {
                    if (a.porcentaje_maximo < b.porcentaje_maximo) return -1;
                    if (a.porcentaje_maximo > b.porcentaje_maximo) return 1;
                    return 0;
                });
                // Ordenarlo

                factor_item_sort.forEach((obj) => {
                    Object.defineProperty(obj, 'factor_corrector_name', {
                        get: function () {
                            let signo_porcentaje =
                                obj.porcentaje_maximo >= 999
                                    ? `> ${
                                          factor_item_sort[
                                              factor_item_sort.length - 2
                                          ].porcentaje_maximo
                                      }`
                                    : `< ${obj.porcentaje_maximo}`;
                            return `${signo_porcentaje}%`;
                        },
                        set: function () {},
                        configurable: true,
                    });
                });

                return factor_item_sort;
            } else {
                return this.factor_corrector;
            }
        },
        isOpenViewFactor: {
            get() {
                return this.$store.state.areaPersonal.calculadora.factorView
                    .isOpenViewFactor;
            },
            set(value) {
                this.$store.commit(
                    'areaPersonal/calculadora/isOpenViewFactor',
                    value
                );
            },
        },
        factorView: {
            get() {
                return this.$store.state.areaPersonal.calculadora.factorView
                    .factor;
            },
            set(value) {
                this.$store.commit(
                    'areaPersonal/calculadora/factorView',
                    value
                );
            },
        },
        ...mapState('areaPersonal/calculadora', {
            currentDate: (state) => state.date,
            selectedComercial: (state) => state.selectedComercial,
            factor_corrector: (state) => state.factor_corrector,
            dateActualInmutable: (state) => state.dateActualInmutable,
        }),
        // ...mapState('login', {
        //     cuenta: (state) => state.cuenta,
        // }),
        ...mapGetters('areaPersonal/calculadora', {
            currentNameMonthYear: 'currentNameMonthYear',
        }),
        ...mapGetters('login', {
            hasManagerPermission: 'hasManagerPermission',
            hasComercialPermission: 'hasComercialPermission',
        }),
    },
    watch: {
        selectedComercial: {
            immediate: true,
            handler: function (newValue) {
                if (newValue != null) {
                    if (this.currentDate) {
                        let params = {
                            commercial: newValue.id,
                            created_on: `${this.currentDate.getFullYear()}-${
                                this.currentDate.getMonth() + 1
                            }`,
                        };
                        if (
                            dateToISOString(this.currentDate) >=
                            this.dateActualInmutable
                        ) {
                            params = { ...params, is_active: true };
                        }
                        this.$store.dispatch(
                            'areaPersonal/calculadora/fetchFactorCorrector',
                            params
                        );
                    }
                }
            },
        },
        currentDate: {
            immediate: true,
            handler: function (newValue, oldValue) {
                if (
                    this.hasManagerPermission &&
                    this.selectedComercial &&
                    newValue != oldValue
                ) {
                    let params = {
                        commercial: this.selectedComercial.id,
                        created_on: `${newValue.getFullYear()}-${
                            newValue.getMonth() + 1
                        }`,
                    };

                    if (dateToISOString(newValue) >= this.dateActualInmutable) {
                        params = { ...params, is_active: true };
                    }
                    this.$store.dispatch(
                        'areaPersonal/calculadora/fetchFactorCorrector',
                        params
                    );
                } else if (
                    this.hasComercialPermission &&
                    newValue != oldValue
                ) {
                    let params = {
                        commercial: this.cuenta.id,
                        created_on: `${newValue.getFullYear()}-${
                            newValue.getMonth() + 1
                        }`,
                    };

                    if (dateToISOString(newValue) >= this.dateActualInmutable) {
                        params = { ...params, is_active: true };
                    }

                    this.$store.dispatch(
                        'areaPersonal/calculadora/fetchFactorCorrector',
                        params
                    );
                }
            },
        },
        isOpenViewFactor: {
            immediate: true,
            handler: function (newValue, oldValue) {
                if (!newValue && oldValue) {
                    this.factorView = null;
                }
            },
        },
    },
};
</script>